import Grid from "@material-ui/core/Grid";
import React, {Fragment, useState} from "react";
import {TrimmedTextField} from "../../_shared/TrimmedTextField";
import {FormStatus} from "../../../models/shared";
import IconButton from "@material-ui/core/IconButton";
import RemoveCircle from "@material-ui/icons/RemoveCircle";
import AddIcon from "@material-ui/icons/Add";
import Button from "@material-ui/core/Button";
import CSVImport from "../../_shared/CSVImport";
import {AddMachineForm, MachineToAddModel} from "../../../models/membership.models";
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import * as _ from "lodash";
import {useNotification} from "../../ui/notification/NotificationProvider";

const useStyles = makeStyles(theme => ({
    formsContainer: {
        marginTop: theme.spacing(2)
    },
    addBtn: {
        marginTop: theme.spacing(4)
    },
    actions: {
        '& > *': {
            marginLeft: theme.spacing(2)
        }
    },
    actionContainer: {
        width: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    deleteBtn: {
        color: theme.palette.error.main
    },
    itemContainer:{
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1)
    },
    byEmailRow: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        '& > .MuiFormControl-root': {
            margin: theme.spacing(1),
            minWidth: 200,
            flexGrow: 1
        }
    }
}));

const AddMachinesByEmail = (props: {machineEmails: MachineToAddModel[], setMachineEmails: (arg0: { (prev: MachineToAddModel[]): MachineToAddModel[] }) => void, forms: AddMachineForm[]}) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const [emailId, setEmailId] = useState(1);
    const {pushNotification} = useNotification();

    const handleFormChange = (name: string, value: string, f: MachineToAddModel) => {
        const currentMachine = props.machineEmails.find(x => x.id === f.id);
        if (!currentMachine) return;
        currentMachine.email = value;
        props.setMachineEmails((prev: MachineToAddModel[]) => {
            const currentIndex = prev.findIndex(x => x.id === f.id);
            const result = [...prev];
            result[currentIndex] = _.merge({}, result[currentIndex], {email: value});
            return result;
        });
    };

    const onAddItem = (machineToAdd: MachineToAddModel) => {
        props.setMachineEmails((prev: MachineToAddModel[]) => [...prev, machineToAdd]);
    };

    const buildItemData = (row?: string[], index?: number): MachineToAddModel => {
        const itemToReturn = {
            id: emailId + (index || 0),
            email: row && row[0] || "",
            status: FormStatus.none
        };
        setEmailId(prev => prev + 1);
        return itemToReturn;
    };

    const resetHandler = () => {
        props.setMachineEmails((prev: MachineToAddModel[]) => [] as MachineToAddModel[]);
    };

    const CSVFormat = {
        headers: ['Email'],
        examples: [
            ['js.smith@gmail.com'],
            ['j.doe@gmail.com']
        ]
    };

    const loadCSVData = (data: string[][]) => {
        props.setMachineEmails(prev => prev.filter(x => x.email || props.forms.some(y => y.id === x.id && y.status === FormStatus.successful)));

        data
            .map((row: string[], index: number) => buildItemData(row, index))
            .forEach(onAddItem)
    };

    const onLoadCSVError = (errorMsg: any, errorCode: any) => {
        const errorCodeMsg = errorCode ? '\nError code: ' + errorCode : '';
        if (errorMsg) {
            pushNotification({
                message: errorMsg + errorCodeMsg,
                severity: 'warning'
            });
        }
    };

    const handleDeleteItem = (f: MachineToAddModel) => {
        props.setMachineEmails((prev: MachineToAddModel[]) => prev.filter(x => x.id !== f.id));
    };

    return <Fragment>
        <Grid container className={classes.formsContainer}>
            {
                props.machineEmails
                    .map((f) =>
                            <Grid className={classes.byEmailRow}>
                                <TrimmedTextField
                                    name='email'
                                    value={f.email}
                                    onFormChange={(name: string, value: string) => handleFormChange(name, value, f)}
                                    disabled={props.forms.some(x => x.status === FormStatus.successful && x.id === f.id)}
                                    label="Email">
                                </TrimmedTextField>
                                <div className={classes.actionContainer}>
                                    <IconButton aria-label="delete" className={classes.deleteBtn}
                                                onClick={() => handleDeleteItem(f)}>
                                        <RemoveCircle/>
                                    </IconButton>
                                </div>
                            </Grid>
                    )
            }
        </Grid>
        <Grid container justify="flex-start">
            <IconButton aria-label="add" className={classes.addBtn}
                        onClick={() => onAddItem(buildItemData())}
                        disabled={props.machineEmails.some(x => !x.email.trim() )}>
                <AddIcon/>
            </IconButton>
        </Grid>
        <Grid container justify="flex-end" className={classes.actions}>
            <Button variant="outlined" color="primary" size="medium"
                    onClick={resetHandler}>
                {t('_Common.Labels.Reset')}
            </Button>
        </Grid>
        <CSVImport displayedLabel={t('_Common.Labels.CSV')}
                   format={CSVFormat}
                   onComplete={loadCSVData}
                   onError={onLoadCSVError}/>
    </Fragment>
};

export default AddMachinesByEmail;
